const BlankLayout = ({ children }) => (
  <div style={{ minHeight: '100vh' }}>{children}</div>
)
export default BlankLayout